import AbstractListView from '@UI/Store/AbstractListView';
import type BeneficiaryContactView from '@UI/Store/BeneficiaryContacts/Views/BeneficiaryContactView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `beneficiaryId` is the scope this page belongs to: `stopOn` compares it against the beneficiary
 * currently on screen to decide whether the cached page is still valid. `totalRecords` counts every
 * contact server-side (not just this page) — it is what lets the screen detect a truncation past the
 * 200-row server maximum, since this list is never paginated on screen.
 */
class BeneficiaryContactsListView extends AbstractListView<BeneficiaryContactView> {
	readonly beneficiaryId: number;
	readonly totalRecords: number;

	constructor(list: readonly BeneficiaryContactView[], beneficiaryId: number, totalRecords: number) {
		super(list, 'BeneficiaryContactsListView');

		this.beneficiaryId = beneficiaryId;
		this.totalRecords = totalRecords;

		Object.freeze(this);
	}

	addContact(contact: BeneficiaryContactView): BeneficiaryContactsListView {
		return new BeneficiaryContactsListView(
			[...this.list, contact],
			this.beneficiaryId,
			this.totalRecords + 1,
		);
	}

	updateContact(contact: BeneficiaryContactView): BeneficiaryContactsListView {
		return new BeneficiaryContactsListView(
			this.list.map((entry) => (entry.id === contact.id ? contact : entry)),
			this.beneficiaryId,
			this.totalRecords,
		);
	}

	removeContact(contactId: number): BeneficiaryContactsListView {
		return new BeneficiaryContactsListView(
			this.list.filter((entry) => entry.id !== contactId),
			this.beneficiaryId,
			Math.max(0, this.totalRecords - 1),
		);
	}
}

export default BeneficiaryContactsListView;
